import React, {Component} from 'react';
import BundleTableItem from './BundleTableItem/BundleTableItem';

export default class BundlePackageOrderingTable extends Component {
  constructor (props) {
    super (props);

    this.state = {
      activeItemId: '',
    };

    this.handleActiveItemChange = this.handleActiveItemChange.bind (this);
  }

  handleActiveItemChange (itemId) {
    this.setState ({activeItemId: itemId});
  }

  render () {
    const {orderingItems} = this.props;

    return (
      <div>
        <p className="ordering-table__instruction print-hidden">
          Select row to learn more about the product
        </p>
        <div className="main-product__table ordering-table ordering-table--with-description">
          <table>
            <thead>
              <tr>
                <th>Product number</th>
                <th>Product description</th>
              </tr>
            </thead>
            <tbody>
              {orderingItems.map (item => (
                <BundleTableItem
                  item={item}
                  key={item.ProductNumber}
                  activeItemId={this.state.activeItemId}
                  handleActiveItemChange={this.handleActiveItemChange}
                  open={this.state.activeItemId === item.ProductNumber}
                />
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}
